import React, { useState, useEffect } from 'react';
import './App.css';

const AibridgeLanding = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // SEO: Add page title effect
  useEffect(() => {
    document.title = 'AIBridge - Venta de Seguros con IA Generativa | Automatización WhatsApp';
  }, []);

  const handleFormChange = (e) => {
    setContactForm({
      ...contactForm,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', contactForm);
    alert('¡Gracias por tu interés! Nos pondremos en contacto contigo pronto.');
    setContactForm({ name: '', email: '', company: '', message: '' });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-slate-200' 
          : 'bg-transparent'
      }`} role="navigation" aria-label="Navegación principal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img 
                src="/logoaibridge.png" 
                alt="AlBridge - Venta de Seguros con IA Generativa" 
                className={`h-10 w-auto transition-all duration-300 ${
                  isScrolled 
                    ? 'filter-none' 
                    : 'brightness-0 invert'
                }`}
              />
            </div>
            <div className="hidden md:flex space-x-8">
              <a href="#inicio" className={`transition-colors font-medium ${
                isScrolled 
                  ? 'text-slate-700 hover:text-blue-600' 
                  : 'text-white hover:text-blue-300'
              }`} aria-label="Ir al inicio">
                Inicio
              </a>
              <a href="#productos" className={`transition-colors font-medium ${
                isScrolled
                  ? 'text-slate-700 hover:text-blue-600'
                  : 'text-white hover:text-blue-300'
              }`} aria-label="Ir a productos y servicios">
                Productos y Servicios
              </a>
              <a href="#contacto" className={`transition-colors font-medium ${
                isScrolled 
                  ? 'text-slate-700 hover:text-blue-600' 
                  : 'text-white hover:text-blue-300'
              }`} aria-label="Ir a la sección de contacto">
                Contacto
              </a>
            </div>
            <a href="#contacto" className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-2 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl" aria-label="Solicitar demostración gratuita">
              Solicitar Demo
            </a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1655393001768-d946c97d6fd1"
            alt="Tecnología de inteligencia artificial moderna con servidores y equipos tecnológicos avanzados"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/90 via-slate-900/80 to-blue-800/90"></div>
        </div>
        
        {/* Content */}
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              Revoluciona tus
              <span className="block bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
                Ventas de Seguros
              </span>
              con IA Generativa
            </h2>
            <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
              Automatiza la venta de seguros digitales vía WhatsApp y optimiza la calidad 
              de tus procesos comerciales con tecnología de Inteligencia Artificial avanzada.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a href="#contacto" className="bg-gradient-to-r from-blue-500 to-cyan-400 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:from-blue-600 hover:to-cyan-500 transition-all transform hover:scale-105 shadow-2xl hover:shadow-blue-500/25" aria-label="Solicitar demostración gratuita de AIBridge">
                Solicitar Demo Gratuito
              </a>
              <a href="#productos" className="border-2 border-white text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-white hover:text-slate-900 transition-all" aria-label="Ver productos y servicios de AIBridge">
                Ver Productos y Servicios
              </a>
            </div>
          </div>

          {/* Scroll Indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce" aria-label="Desplázate hacia abajo para ver más contenido">
            <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </header>


      {/* Products and Services Section */}
      <section id="productos" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Nuestros Servicios
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Soluciones tecnológicas avanzadas diseñadas específicamente para la industria de seguros            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
              {/* Service 1 */}
              <article className="group">
                <div className="relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform group-hover:scale-105">
                  <img 
                    src="https://images.unsplash.com/photo-1600426976794-d223e39cc5d4"
                    alt="Smartphone mostrando interfaz de WhatsApp Business para automatización de ventas de seguros con IA"
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      Venta de Seguros Digitales vía WhatsApp
                    </h3>
                    <p className="text-blue-100">
                      Canal de venta automatizado con IA Generativa
                    </p>
                  </div>
                </div>
                <div className="mt-8 space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></div>
                    <p className="text-slate-700">Chatbots inteligentes con procesamiento de lenguaje natural</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></div>
                    <p className="text-slate-700">Integración completa con CRM y plataformas de emisión</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></div>
                    <p className="text-slate-700">Trazabilidad completa del proceso de venta</p>
                  </div>
                </div>
              </article>

              {/* Service 2 */}
              <article className="group">
                <div className="relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform group-hover:scale-105">
                  <img 
                    src="https://images.pexels.com/photos/5475750/pexels-photo-5475750.jpeg"
                    alt="Profesional analizando dashboard de control de calidad con IA generativa para auditoría de ventas de seguros"
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      Auditoría y Control de Calidad de Ventas
                    </h3>
                    <p className="text-slate-100">
                      Análisis automatizado con IA Generativa
                    </p>
                  </div>
                </div>
                <div className="mt-8 space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></div>
                    <p className="text-slate-700">Transcripción automatizada de llamadas y chats</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></div>
                    <p className="text-slate-700">Verificación automática de scripts y ofertas</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></div>
                    <p className="text-slate-700">Generación automática de reportes de calidad</p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-gradient-to-br from-slate-900 to-blue-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                ¿Por qué elegir aibridge?
              </h2>
              <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                Transformamos la industria de seguros con tecnología de vanguardia
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  title: "Incrementa tus Ventas",
                  description: "Hasta 300% más de conversiones con automatización inteligente",
                  icon: "📈"
                },
                {
                  title: "Reduce Costos Operativos",
                  description: "Automatiza procesos y libera recursos para tareas estratégicas",
                  icon: "💰"
                },
                {
                  title: "Mejora la Calidad",
                  description: "Control de calidad automatizado y cumplimiento normativo",
                  icon: "✅"
                },
                {
                  title: "Disponibilidad 24/7",
                  description: "Atención al cliente automatizada sin interrupciones",
                  icon: "🕐"
                },
                {
                  title: "Integración Completa",
                  description: "Compatible con tus sistemas actuales de CRM y emisión",
                  icon: "🔗"
                },
                {
                  title: "Análisis Avanzado",
                  description: "Insights profundos sobre tu proceso de ventas",
                  icon: "📊"
                }
              ].map((benefit, index) => (
                <article key={index} className="bg-white/10 backdrop-blur-md rounded-xl p-8 hover:bg-white/20 transition-all duration-300 transform hover:scale-105">
                  <div className="text-4xl mb-4" aria-hidden="true">{benefit.icon}</div>
                  <h3 className="text-2xl font-bold text-white mb-4">{benefit.title}</h3>
                  <p className="text-blue-100">{benefit.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-blue-600 to-cyan-500">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              ¿Listo para revolucionar tus Ventas y Post Venta?
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Solicita una demo personalizada y descubre cómo AIBridge puede transformar tu negocio
            </p>
            <a href="#contacto" className="bg-white text-blue-600 px-8 py-4 rounded-xl text-lg font-bold hover:bg-slate-100 transition-all transform hover:scale-105 shadow-2xl" aria-label="Solicitar demostración gratuita personalizada">
              Solicitar Demo Gratuito
            </a>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contacto" className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
                Contáctanos
              </h2>
              <p className="text-xl text-slate-600">
                Estamos aquí para ayudarte a transformar tu negocio de seguros
              </p>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl p-8 shadow-2xl">
              <form onSubmit={handleSubmit} className="space-y-6" noValidate>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-slate-700 mb-2">
                      Nombre *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={contactForm.name}
                      onChange={handleFormChange}
                      required
                      autoComplete="name"
                      className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
                      placeholder="Tu nombre completo"
                      aria-describedby="name-help"
                    />
                    <div id="name-help" className="sr-only">Ingresa tu nombre completo</div>
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={contactForm.email}
                      onChange={handleFormChange}
                      required
                      autoComplete="email"
                      className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
                      placeholder="tu@email.com"
                      aria-describedby="email-help"
                    />
                    <div id="email-help" className="sr-only">Ingresa tu dirección de correo electrónico</div>
                  </div>
                </div>
                <div>
                  <label htmlFor="company" className="block text-sm font-semibold text-slate-700 mb-2">
                    Empresa
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={contactForm.company}
                    onChange={handleFormChange}
                    autoComplete="organization"
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all"
                    placeholder="Nombre de tu aseguradora"
                    aria-describedby="company-help"
                  />
                  <div id="company-help" className="sr-only">Opcional: Nombre de tu empresa o aseguradora</div>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-slate-700 mb-2">
                    Mensaje
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={contactForm.message}
                    onChange={handleFormChange}
                    rows={5}
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all resize-none"
                    placeholder="Cuéntanos sobre tu empresa y cómo podemos ayudarte..."
                    aria-describedby="message-help"
                  ></textarea>
                  <div id="message-help" className="sr-only">Opcional: Cuéntanos más sobre tus necesidades</div>
                </div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-blue-700 hover:to-blue-800 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl"
                    aria-label="Enviar formulario de contacto"
                  >
                    Enviar Mensaje
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12" role="contentinfo">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent mb-4">
                aibridge
              </h3>
              <p className="text-slate-300 mb-4">
                Verticales de Negocio especializadas en tecnología con foco exclusivo en la industria de seguros.
              </p>
              <p className="text-slate-400 text-sm">
                Transformando la venta de seguros con Inteligencia Artificial Generativa.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Servicios</h4>
              <ul className="space-y-2 text-slate-300">
                <li>Venta de Seguros vía WhatsApp</li>
                <li>Auditoría con IA</li>
                <li>Control de Calidad</li>
                <li>Integración CRM</li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Contacto</h4>
              <ul className="space-y-2 text-slate-300">
                <li>
                  <a href="mailto:info@aibridge.cl" className="hover:text-blue-300 transition-colors">
                    info@aibridge.cl
                  </a>
                </li>
                <li>
                  <a href="tel:+56228823010" className="hover:text-blue-300 transition-colors">
                  +56 22 8823010
                  </a>
                </li>
                <li>Demo Gratuito</li>
                <li>Soporte Técnico</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-400">
            <p>&copy; 2025 aibridge. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

function App() {
  return <AibridgeLanding />;
}

export default App;
